(function() {
  var selector = '[data-product-card-video-defer]';
  var templateSelector = 'template[data-product-card-video-template]';
  var observedAttr = 'data-product-card-video-observed';
  var hydratedAttr = 'data-product-card-video-hydrated';
  var playAttr = 'data-product-card-video-play';
  var observer = null;
  var mutationObserver = null;
  var listenersBound = false;
  var bootstrapBound = false;
  var idle = window.requestIdleCallback || function(callback) {
    return window.setTimeout(callback, 1200);
  };

  function safePlay(video) {
    if (!video || typeof video.play !== 'function') return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function() {});
    }
  }

  function hidePosterWhenReady(card, video) {
    var poster = card.querySelector('[data-pr-img]');
    if (!poster) return;
    var hidePoster = function() {
      poster.hidden = true;
    };
    video.addEventListener('loadeddata', hidePoster, { once: true });
    video.addEventListener('canplay', hidePoster, { once: true });
  }

  function hydrate(card) {
    if (!card || card.getAttribute(hydratedAttr) === 'true') return;
    var template = card.querySelector(templateSelector);
    if (!template || !template.content || !template.content.firstElementChild) return;
    var video = template.content.firstElementChild.cloneNode(true);
    video.setAttribute('preload', 'none');
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    hidePosterWhenReady(card, video);
    card.insertBefore(video, card.firstElementChild);
    card.setAttribute(hydratedAttr, 'true');
    if (card.getAttribute(playAttr) === 'true' || video.autoplay) safePlay(video);
  }

  function hydrateFromEvent(event) {
    if (!event.target.closest) return;
    var card = event.target.closest(selector);
    if (!card) return;
    card.setAttribute(playAttr, 'true');
    if (card.getAttribute(hydratedAttr) === 'true') {
      safePlay(card.querySelector('video'));
      return;
    }
    hydrate(card);
  }

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        hydrate(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '350px 0px' });
    return observer;
  }

  function observeCard(card) {
    if (!card || card.getAttribute(observedAttr) === 'true') return;
    card.setAttribute(observedAttr, 'true');
    var viewportObserver = getObserver();
    if (viewportObserver) {
      viewportObserver.observe(card);
    } else {
      hydrate(card);
    }
  }

  function observeCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll(selector);
    if (!cards.length) return false;
    cards.forEach(observeCard);
    return true;
  }

  function bindInteractionListeners() {
    if (listenersBound) return;
    listenersBound = true;
    document.addEventListener('pointerover', hydrateFromEvent, { passive: true });
    document.addEventListener('touchstart', hydrateFromEvent, { passive: true });
    document.addEventListener('focusin', hydrateFromEvent);
  }

  function observeMutations() {
    if (mutationObserver || !('MutationObserver' in window)) return;
    mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(selector)) observeCard(node);
          observeCards(node);
        });
      });
    });
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function start(root) {
    if (!observeCards(root)) return false;
    bindInteractionListeners();
    observeMutations();
    return true;
  }

  function bootstrapFromEvent(event) {
    if (!event.target.closest) return;
    var card = event.target.closest(selector);
    if (!card) return;
    unbindBootstrapListeners();
    bindInteractionListeners();
    observeMutations();
    hydrateFromEvent(event);
  }

  function bindBootstrapListeners() {
    if (bootstrapBound) return;
    bootstrapBound = true;
    document.addEventListener('pointerover', bootstrapFromEvent, { passive: true });
    document.addEventListener('touchstart', bootstrapFromEvent, { passive: true });
    document.addEventListener('focusin', bootstrapFromEvent);
  }

  function unbindBootstrapListeners() {
    if (!bootstrapBound) return;
    bootstrapBound = false;
    document.removeEventListener('pointerover', bootstrapFromEvent);
    document.removeEventListener('touchstart', bootstrapFromEvent);
    document.removeEventListener('focusin', bootstrapFromEvent);
  }

  document.addEventListener('shopify:section:load', function(event) {
    idle(function() {
      start(event.target);
    });
  });

  window.addEventListener('load', function() {
    idle(function() {
      start(document);
    });
  }, { once: true });

  bindBootstrapListeners();
})();
